import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../../stores/AppStore";
import { TaskInformation, TaskList, Title, values_nfse } from "./RelatorioData";
import { MDBCol, MDBRow } from "mdbreact";
import { Button } from "@blueprintjs/core";
import FolderTree, { } from 'react-folder-tree';
import { observable } from "mobx";
import { RelatorioStore } from "../../../stores/relatorio/RelatorioStore";
import { ListManager } from "react-beautiful-dnd-grid";
import 'react-folder-tree/dist/style.css';
import { percorrerValores } from "../../../utils";

const ScreenSizeDetector = require('screen-size-detector');
const screen = new ScreenSizeDetector();

const EditIcon = (...args) => null;
const DeleteIcon = (...args) => null;
const CancelIcon = (...args) => null;
const FolderIcon = (...args) => null;
const FileIcon = (...args) => null;
const OKIcon = (...args) => null
const FolderOpenIcon = (...args) => null

interface State {
  sortedList: any
}

@observer
export class RelatorioNfseForm extends React.Component<{}, State> {

  obs = observable({
    treeValues: [] as any,
    treeData: values_nfse(),
    columns: [] as any
  })

  constructor(props) {
    super(props);

    if (RelatorioStore.obs.selectedEmpresa.cnpj == "") {
      AppStore.setLocation("/relatorios");
    }

    if (RelatorioStore.obs.select_relatorio.treeData.length != 0) {
      this.obs.treeData = RelatorioStore.obs.select_relatorio.treeData
    }

    if (RelatorioStore.obs.select_relatorio.columns.length != 0) {
      this.obs.columns = RelatorioStore.obs.select_relatorio.columns
    }

    this.state = {
      sortedList: this.sortedList(this.obs.columns)
    }

    AppStore.setTitle("Relatório");
  }

  handleSave() {
    let params = {
      columns: this.state.sortedList,
      treeData: this.obs.treeValues
    }

    let columns = this.state.sortedList.map(x => x)

    RelatorioStore.obs.columns = columns
    RelatorioStore.obs.relatorio = params
    AppStore.setLocation("/relatorio/filtro");
  }

  handleCancel() {
    window.location.href = "/relatorios"
  }

  sortList = () => {
    this.setState({ ...this.state, sortedList: this.sortedList(this.state.sortedList) })
  }

  sortedList(list) {
    return list.slice().sort((first, second) => first.order - second.order);
  }

  reorderList = (sourceIndex, destinationIndex) => {
    if (destinationIndex === sourceIndex) {
      return;
    }
    const list = this.state.sortedList;
    if (destinationIndex === 0) {
      list[sourceIndex].order = list[0].order - 1;
      this.sortList();
      return;
    }
    if (destinationIndex === list.length - 1) {
      list[sourceIndex].order = list[list.length - 1].order + 1;
      this.sortList();
      return;
    }
    if (destinationIndex < sourceIndex) {
      list[sourceIndex].order = (list[destinationIndex].order + list[destinationIndex - 1].order) / 2;
      this.sortList();
      return;
    }
    list[sourceIndex].order = (list[destinationIndex].order + list[destinationIndex + 1].order) / 2;
    this.sortList();
  }

  render() {

    const onTreeStateChange = (state) => {
      let itens: any = []
      let valores = []

      if (state.checked == 0) {
        this.setState({ sortedList: [] }, () => { return });
      }

      try {
        itens = this.state.sortedList
        valores = [...this.state.sortedList].map(x => x.id)
      } catch (ex) { }
      state.children.forEach((x) => {
        x.children.forEach((value) => {
          if (value.children) {
            value.children.forEach((value2) => {
              percorrerValores(value2, itens, valores);
            });
          } else {
            percorrerValores(value, itens, valores);
          }
        });
      });

      this.setState({ sortedList: itens }, () => {
        this.obs.treeValues = state
      });
    };

    const onNameClick = () => { }

    function ListElement({ item: { header } }) {
      return (
        <div>
          <TaskInformation>
            <p>{header}</p>
          </TaskInformation>
        </div>);
    }

    const maxItems = () => {
      let width = screen.width;
      let maxItens = 3;

      if (width >= 1200 && width < 1300) {
        maxItens = 4;
      } else if (width >= 1400 && width < 1650) {
        maxItens = 5;
      } else if (width >= 1650 && width < 1900) {
        maxItens = 6;
      } else if (width >= 1900 && width < 2150) {
        maxItens = 7;
      } else if (width >= 2150 && width < 2400) {
        maxItens = 8;
      } else if (width >= 2400 && width < 2660) {
        maxItens = 9;
      } else if (width >= 2660) {
        maxItens = 10;
      }

      return maxItens;
    }

    const maxHeight = () => {
      let height = screen.height;

      if (height < 800) {
        return "450px"
      } else if (height >= 800 && height < 850) {
        return "500px"
      } else if (height >= 850 && height < 850) {
        return "580px"
      } else {
        return "610px"
      }
    }

    return (
      <>
        <MDBRow>
          <MDBCol md="2" style={{ maxHeight: maxHeight(), overflow: "auto" }}>
            <FolderTree
              data={this.obs.treeData}
              onChange={onTreeStateChange}
              iconComponents={{
                EditIcon, DeleteIcon, CancelIcon, FolderIcon, FileIcon, OKIcon, FolderOpenIcon
              }}
              onNameClick={onNameClick}
              initCheckedStatus='custom'
              initOpenStatus='custom'
            />
          </MDBCol>

          <MDBCol md="10">
            <TaskList style={{ maxHeight: maxHeight() }}>
              <Title>{"Colunas"}</Title>
              <ListManager
                items={this.state.sortedList}
                direction="horizontal"
                maxItems={maxItems()}
                render={(item) => <ListElement item={item} />}
                onDragEnd={this.reorderList}
              />
            </TaskList>
          </MDBCol>
        </MDBRow>

        <div style={{ marginTop: "50px" }}>
          <Button
            intent="primary"
            onClick={() => this.handleSave()}
            style={{ marginRight: "10px" }}
          >
            Continuar
          </Button>
          <Button
            onClick={() => this.handleCancel()}
          >
            Cancelar
          </Button>
        </div>
      </>
    );
  }
}

export default RelatorioNfseForm;
